'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"
import organizationService from "@/api/organizationService";

export default {
    async updateIntegration(json) {
        const data = {
            method: 'post',
            url: 'integration',
            body: json
        }

        const response = await api.api(data)
        if (response.status === 200 || response.status === 201) {
            notify.alert.success('Bank Integration successfully updated')
            return true
        }
    },
}
